import React from "react";
import { plansData } from "../../data/plansData";
import "./Plans.css";
import whiteTick from "../../assets/whiteTick.png";

function Plans() {
  const handleClick = () => {
    window.open(
      "https://api.whatsapp.com/send?phone=<+905434242415>&text=<Bilgi_almak_istiyorum!>",
      "_blank"
    );
  };

  return (
    <div className="plans-container" id="plans">
      <div className="blur plan1"></div>
      <div className="blur plan2"></div>
      <div className="programs-header" style={{ gap: "4rem" }}>
        {/* <span className="bosluk-text">aylık </span> */}
        <span> Paketler</span>
        {/* <span className="bosluk-text">ücretleri</span> */}
      </div>
      {/* Planlar */}

      <div className="plans">
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            <p>
              {plan.icon} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
              {i !== 2 ? plan.features[0] : "Personal Trainer"}
            </p>
            <span>{plan.name}</span>
            <span>{plan.price}₺</span>

            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="feature">
                  <img src={whiteTick} alt="" />
                  <span key={i}>{feature}</span>
                </div>
              ))}
            </div>
            <span>
              {i === 2
                ? "*Suplamentler Dahil Değildir"
                : "Nakit ve Havalede %5 İndirim!"}
            </span>
            <button onClick={handleClick} className="btn">
              Tıklayın!
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Plans;
